import {
  DetailsDisplay,
  DetailsDisplayOrientation,
  useEvidenceContext,
} from "@/Features";
import { useEvidenceColumnDefinitions } from "../Hooks";
import { Loader } from "@monolith-forensics/monolith-ui";

export const EvidenceDetailsDisplay: React.FC<{
  orientation: DetailsDisplayOrientation;
  style?: React.CSSProperties;
  dataFieldIgnoreList?: string[];
  hideEmptyFields?: boolean;
}> = ({ orientation, style, dataFieldIgnoreList, hideEmptyFields = false }) => {
  const evidenceContext = useEvidenceContext();
  if (!evidenceContext) {
    throw new Error("Evidence context not found");
  }
  const { data: evidenceInfo, isLoading, isFetched, update } = evidenceContext;

  const {
    columnDefinitions,
    customFields,
    isLoading: isColumnDefinitionsLoading,
    isFetched: isColumnDefinitionsFetched,
  } = useEvidenceColumnDefinitions();

  const handleUpdate = ({
    rowData,
    updateData,
  }: {
    rowData: any;
    updateData: any;
  }) => {
    update?.(updateData);
  };

  if (isLoading || isColumnDefinitionsLoading) {
    return <Loader />;
  }

  const typeID = evidenceInfo?.evi_type_id;

  // filter column definitions to only include custom fields that are associated with the evidence type
  const filteredColumnDefinitions = columnDefinitions.filter((col) => {
    if (col.dataField.includes("custom_field_")) {
      const fieldID = col.dataField.split("custom_field_")[1];

      const field = customFields?.data?.find(
        (field) => field.field_id === parseInt(fieldID)
      );

      // return column if evidence types are not specified
      if (!field?.type_ids || field.type_ids.length === 0) {
        return true;
      }

      return field.type_ids?.includes(Number(typeID));
    }
    return true;
  });

  return (
    <DetailsDisplay
      columnDefinitions={filteredColumnDefinitions}
      data={evidenceInfo || {}}
      orientation={orientation}
      style={style}
      dataFieldIgnoreList={dataFieldIgnoreList}
      hideEmptyFields={hideEmptyFields}
      onUpdate={handleUpdate}
    />
  );
};
